import { NgModule } from '@angular/core';
import { SharedModule } from 'Public_old/src/app/appShares.module';
import { AttentionCardWrapper } from './attention-card.wrapper';
import { ChangeUnitWrapperComponent } from './change-unit.wrapper';
import { FooterWrapperComponent } from './footer.wrapper';
import { HeaderWrapperComponent } from './header.wrapper';
import { HomeWrapperComponent } from './home.wrapper';
import { PopoverManagerComponent } from './popover_manager.wrapper';
import { VideoCallWrapperComponent } from './video-call.wrapper';
import { VisitsWrapperComponent } from './visits.wrapper';
import { DeviceGatewayWrapperComponent } from './device-gateway.wrapper';
import { LanguageSelectWrapperComponent } from './language_select.wrapper';
import { LicenceHolderFooterComponent } from 'Public_old/src/app/Views/licenceholder-footer.component';
import { CookiePolicyWrapperComponent } from './cookie_policy.wrapper';
import { ReceptionHomeWrapperComponent } from './reception-home.wrapper';
import { MyAccountWrapperComponent } from './my_account.wrapper';
import { SignInWrapperComponent } from './sign-in.wrapper';
import { SignInFinishWrapperComponent } from './sign-in-finish.wrapper';
import { CreateNewMessageWrapper } from './create-new-message.wrapper';
import { RedRobinWrapper } from './red_robin.wrapper';
import { BookingWrapper } from './booking.wrapper';

@NgModule({
	imports: [SharedModule],
	declarations: [
		LicenceHolderFooterComponent,
		HomeWrapperComponent,
		FooterWrapperComponent,
		HeaderWrapperComponent,
		VideoCallWrapperComponent,
		PopoverManagerComponent,
		AttentionCardWrapper,
		ChangeUnitWrapperComponent,
		VisitsWrapperComponent,
		DeviceGatewayWrapperComponent,
		LanguageSelectWrapperComponent,
		CookiePolicyWrapperComponent,
		ReceptionHomeWrapperComponent,
		RedRobinWrapper,
		MyAccountWrapperComponent,
		SignInWrapperComponent,
		SignInFinishWrapperComponent,
		CreateNewMessageWrapper,
		BookingWrapper,
	],
	exports: [
		LicenceHolderFooterComponent,
		HomeWrapperComponent,
		FooterWrapperComponent,
		HeaderWrapperComponent,
		VideoCallWrapperComponent,
		PopoverManagerComponent,
		AttentionCardWrapper,
		ChangeUnitWrapperComponent,
		VisitsWrapperComponent,
		DeviceGatewayWrapperComponent,
		LanguageSelectWrapperComponent,
		CookiePolicyWrapperComponent,
		ReceptionHomeWrapperComponent,
		RedRobinWrapper,
		MyAccountWrapperComponent,
		SignInWrapperComponent,
		SignInFinishWrapperComponent,
		CreateNewMessageWrapper,
		BookingWrapper,
	],
	providers: [],
})
export class WrappersModule {}
